export default __webpack_public_path__ + "static/media/Heathrow.160ca51c.jpg";